import { render, staticRenderFns } from "./RegistrationFee.vue?vue&type=template&id=a19b5e2e&scoped=true&"
import script from "./RegistrationFee.vue?vue&type=script&lang=js&"
export * from "./RegistrationFee.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFee.vue?vue&type=style&index=0&id=a19b5e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19b5e2e",
  null
  
)

export default component.exports